var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-row",
    [
      _c(
        "b-col",
        { attrs: { md: "12" } },
        [
          _c(
            "card",
            { staticClass: "stacked-form" },
            [
              _vm.isLoading
                ? _c("l-progress", {
                    staticClass: "mb-2",
                    attrs: {
                      value: 100,
                      height: 20,
                      type: "info",
                      animated: true,
                      striped: true
                    }
                  })
                : _vm._e(),
              _vm._v(" "),
              _c("div", { staticClass: "row mb-5" }, [
                _c(
                  "div",
                  { staticClass: "col-md-6" },
                  [
                    _c("fg-input", { attrs: { label: "Dibuat Oleh" } }, [
                      _c("p", [_vm._v(_vm._s(_vm.model.createdBy))])
                    ]),
                    _vm._v(" "),
                    _c("fg-input", { attrs: { label: "Diperbaharui Oleh" } }, [
                      _c("p", [_vm._v(_vm._s(_vm.model.lastUpdatedBy))])
                    ]),
                    _vm._v(" "),
                    _c("fg-input", { attrs: { label: "Supllier" } }, [
                      _c("p", [_vm._v(_vm._s(_vm.model.supplier))])
                    ]),
                    _vm._v(" "),
                    _c("fg-input", { attrs: { label: "Tanggal Pembelian" } }, [
                      _c("p", [_vm._v(_vm._s(_vm.model.poDate))])
                    ]),
                    _vm._v(" "),
                    _c("fg-input", { attrs: { label: "Status" } }, [
                      _c(
                        "p",
                        [
                          _c(
                            "b-badge",
                            {
                              attrs: {
                                variant: _vm.getStatusColor(_vm.model.status)
                              }
                            },
                            [_vm._v(_vm._s(_vm.getStatus(_vm.model.status)))]
                          )
                        ],
                        1
                      )
                    ])
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "col-md-6" },
                  [
                    _c("fg-input", { attrs: { label: "Total Item Dipesan" } }, [
                      _c("p", [
                        _c("strong", [_vm._v(_vm._s(_vm.totalItemOrdered))])
                      ])
                    ]),
                    _vm._v(" "),
                    _c("fg-input", { attrs: { label: "Total Harga" } }, [
                      _c("p", [
                        _c("strong", [
                          _vm._v(_vm._s(_vm.formatNumber(_vm.total)))
                        ])
                      ])
                    ])
                  ],
                  1
                )
              ]),
              _vm._v(" "),
              _c(
                "b-row",
                [
                  _c("b-col", { attrs: { md: "6" } }, [
                    _c("h4", [_vm._v("Barang yang Dipesan")])
                  ]),
                  _vm._v(" "),
                  _c(
                    "b-col",
                    { staticClass: "text-right", attrs: { md: "6" } },
                    [
                      _vm.model.status === 0
                        ? _c(
                            "b-button",
                            {
                              staticClass: "mt-4",
                              attrs: {
                                variant: "primary",
                                to:
                                  "/pembelian/" + _vm.$route.params.id + "/edit"
                              }
                            },
                            [
                              _c("font-awesome-icon", {
                                attrs: { icon: "plus" }
                              }),
                              _vm._v(" Tambah Item\n          ")
                            ],
                            1
                          )
                        : _vm._e()
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "b-row",
                _vm._l(_vm.model.supplierPoProduct, function(
                  supplierProductPo
                ) {
                  return supplierProductPo.product_color !== null
                    ? _c(
                        "b-col",
                        { key: supplierProductPo.id, attrs: { md: "12" } },
                        [
                          _c(
                            "b-row",
                            { staticClass: "mt-3" },
                            [
                              _c(
                                "b-col",
                                { staticClass: "mb-3", attrs: { md: "6" } },
                                [
                                  _c("strong", [
                                    _vm._v(
                                      _vm._s(
                                        supplierProductPo.product_color
                                          .product_categories.category.name
                                      ) +
                                        " " +
                                        _vm._s(
                                          supplierProductPo.product_color.color
                                            .name
                                        )
                                    )
                                  ]),
                                  _vm._v(" "),
                                  _vm.model.status === 0
                                    ? _c(
                                        "b-button",
                                        {
                                          attrs: {
                                            size: "sm",
                                            variant: "danger"
                                          },
                                          on: {
                                            click: function($event) {
                                              _vm.doDelete(
                                                supplierProductPo.product_color_id
                                              )
                                            }
                                          }
                                        },
                                        [
                                          _c("font-awesome-icon", {
                                            attrs: { icon: "trash" }
                                          })
                                        ],
                                        1
                                      )
                                    : _vm._e()
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "table",
                            {
                              staticClass: "table table-bordered table-striped"
                            },
                            [
                              _c("tr", [
                                _c("th", { attrs: { width: "100" } }, [
                                  _vm._v("Varian")
                                ]),
                                _vm._v(" "),
                                _c("th", { attrs: { width: "100" } }, [
                                  _vm._v("Stock")
                                ]),
                                _vm._v(" "),
                                _c("th", { attrs: { width: "100" } }, [
                                  _vm._v("Stock Saat ini")
                                ]),
                                _vm._v(" "),
                                _c("th", { attrs: { width: "200" } }, [
                                  _vm._v("Memesan")
                                ]),
                                _vm._v(" "),
                                _c("th", { attrs: { width: "250" } }, [
                                  _vm._v("Harga Modal")
                                ]),
                                _vm._v(" "),
                                _c("th", [_vm._v("Total")])
                              ]),
                              _vm._v(" "),
                              _vm._l(_vm.model.poProductSizes, function(
                                product
                              ) {
                                return _c(
                                  "tr",
                                  { key: product.id },
                                  [
                                    product.product_color_id ==
                                    supplierProductPo.product_color.id
                                      ? [
                                          _c("td", [
                                            _vm._v(
                                              _vm._s(
                                                product.product_size.size.name
                                              )
                                            )
                                          ]),
                                          _vm._v(" "),
                                          _c("td", [
                                            _vm._v(
                                              _vm._s(product.product_size.stock)
                                            )
                                          ]),
                                          _vm._v(" "),
                                          _c("td", [
                                            _vm._v(
                                              _vm._s(product.current_stock)
                                            )
                                          ]),
                                          _vm._v(" "),
                                          _c(
                                            "td",
                                            [
                                              _vm.model.status === 0
                                                ? [
                                                    _c(
                                                      "b-row",
                                                      [
                                                        _c(
                                                          "b-col",
                                                          {
                                                            attrs: { md: "8" }
                                                          },
                                                          [
                                                            _c("b-form-input", {
                                                              attrs: {
                                                                type: "number",
                                                                placeholder:
                                                                  "Masukkan jumlah pesanan"
                                                              },
                                                              model: {
                                                                value:
                                                                  product.ordered,
                                                                callback: function(
                                                                  $$v
                                                                ) {
                                                                  _vm.$set(
                                                                    product,
                                                                    "ordered",
                                                                    $$v
                                                                  )
                                                                },
                                                                expression:
                                                                  "product.ordered"
                                                              }
                                                            })
                                                          ],
                                                          1
                                                        ),
                                                        _vm._v(" "),
                                                        _c(
                                                          "b-col",
                                                          {
                                                            attrs: { md: "2" }
                                                          },
                                                          [
                                                            _vm.model.status ===
                                                            0
                                                              ? _c(
                                                                  "b-button",
                                                                  {
                                                                    attrs: {
                                                                      size:
                                                                        "sm",
                                                                      variant:
                                                                        "success"
                                                                    },
                                                                    on: {
                                                                      click: function(
                                                                        $event
                                                                      ) {
                                                                        _vm.doUpdateOrder(
                                                                          product.ordered,
                                                                          product.id
                                                                        )
                                                                      }
                                                                    }
                                                                  },
                                                                  [
                                                                    _vm.isLoadingUpdateOrdered
                                                                      ? _c(
                                                                          "font-awesome-icon",
                                                                          {
                                                                            attrs: {
                                                                              icon:
                                                                                "spinner",
                                                                              spin:
                                                                                ""
                                                                            }
                                                                          }
                                                                        )
                                                                      : _c(
                                                                          "font-awesome-icon",
                                                                          {
                                                                            attrs: {
                                                                              icon:
                                                                                "check"
                                                                            }
                                                                          }
                                                                        )
                                                                  ],
                                                                  1
                                                                )
                                                              : _vm._e()
                                                          ],
                                                          1
                                                        )
                                                      ],
                                                      1
                                                    )
                                                  ]
                                                : [
                                                    _vm._v(
                                                      _vm._s(product.ordered)
                                                    )
                                                  ]
                                            ],
                                            2
                                          ),
                                          _vm._v(" "),
                                          _c("td", [
                                            _vm._v(
                                              _vm._s(
                                                _vm.formatNumber(
                                                  product.product_size
                                                    .capital_price
                                                )
                                              )
                                            )
                                          ]),
                                          _vm._v(" "),
                                          _c("td", [
                                            _vm._v(
                                              _vm._s(
                                                _vm.formatNumber(
                                                  product.product_size
                                                    .capital_price *
                                                    product.ordered
                                                )
                                              )
                                            )
                                          ])
                                        ]
                                      : _vm._e()
                                  ],
                                  2
                                )
                              })
                            ],
                            2
                          )
                        ],
                        1
                      )
                    : _vm._e()
                })
              ),
              _vm._v(" "),
              _c("back-button")
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "bubble-info" },
        [
          _vm.model.status === 0
            ? _c(
                "b-button",
                {
                  staticClass: "float-right",
                  attrs: { type: "submit", variant: "primary" },
                  on: { click: _vm.doSubmit }
                },
                [
                  _vm.isLoading
                    ? _c("font-awesome-icon", {
                        attrs: { icon: "spinner", spin: "" }
                      })
                    : _c("font-awesome-icon", { attrs: { icon: "save" } }),
                  _vm._v(" Perbarui")
                ],
                1
              )
            : _vm._e()
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "b-modal",
        {
          ref: "modal-history",
          attrs: { centered: "", "hide-footer": "", title: "Tambah History" }
        },
        [
          _c(
            "form",
            {
              on: {
                submit: function($event) {
                  $event.preventDefault()
                  return _vm.doSubmitLog($event)
                }
              }
            },
            [
              _c("label", { attrs: { for: "" } }, [_vm._v("Diterima")]),
              _vm._v(" "),
              _c("b-form-input", {
                staticClass: "mb-3",
                attrs: { type: "number" },
                model: {
                  value: _vm.modelLog.accepted,
                  callback: function($$v) {
                    _vm.$set(_vm.modelLog, "accepted", $$v)
                  },
                  expression: "modelLog.accepted"
                }
              }),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "form-group" },
                [
                  _c("label", [_vm._v("Tanggal Diterima")]),
                  _vm._v(" "),
                  _c("el-date-picker", {
                    attrs: { placeholder: "Masukkan Tanggal diterima" },
                    model: {
                      value: _vm.fakeModelLog.date,
                      callback: function($$v) {
                        _vm.$set(_vm.fakeModelLog, "date", $$v)
                      },
                      expression: "fakeModelLog.date"
                    }
                  }),
                  _vm._v(" "),
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.modelLog.date,
                        expression: "modelLog.date"
                      }
                    ],
                    attrs: { type: "hidden", name: "date" },
                    domProps: { value: _vm.modelLog.date },
                    on: {
                      input: function($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.$set(_vm.modelLog, "date", $event.target.value)
                      }
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "b-button",
                {
                  staticClass: "float-left",
                  attrs: { variant: "warning" },
                  on: { click: _vm.hideModal }
                },
                [
                  _c("font-awesome-icon", { attrs: { icon: "times" } }),
                  _vm._v(" Canle")
                ],
                1
              ),
              _vm._v(" "),
              _c("save-data-button", {
                attrs: {
                  disabled: _vm.saveButtonData.isLoading,
                  "is-create": _vm.$route.params.id !== undefined,
                  state:
                    _vm.saveButtonData.isLoading &&
                    _vm.saveButtonData.state === 1
                      ? 2
                      : _vm.saveButtonData.state,
                  "is-loading": _vm.saveButtonData.isLoading
                }
              })
            ],
            1
          )
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-24224ea2", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-24224ea2","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Dashboard/Pages/Pos/Show.vue
// module id = 6Wpl
// module chunks = 4